module.exports = __webpack_public_path__ + "static/external/Notion_Slack.fca3e8a4ee876c5b736198a5fbf5a9b5.png";